import React from 'react';
import client from '@/store/client';
import IconReplay from '@/assets/img/icon_replay.png';
import IconReplayC from '@/assets/img/icon_replay_w.png';
import IconWeb from '@/assets/img/icon_web.png';
import IconQuotation from '@/assets/img/quotation.png';
import IconExecute from '@/assets/img/icon_execute.png';
import { SVGPureIcon } from '@/ui';
import fieldCategoryStore from '@/components/field-category/store';
/**
 * 案例广场-案例卡片
 * @param {*} param0
 * @returns
 */
const AgentItemCard = ({
  key,
  data,
  lineClamp = 2,
  className = '',
  execute,
  secne,
}) => {
  const isAgentHome = secne == 'agent_home';
  /** 查看回放 */
  const handleReplay = share_id => {
    client.openPage(`/share/mcp?id=${share_id}`);
  };

  /** 查看网页 */
  const handleWeb = share_id_html => {
    client.openPage(`/share/html?id=${share_id_html}`);
  };

  // 高亮按钮
  const [hlBtn, sethlBtn] = React.useState(null);
  React.useEffect(() => {
    sethlBtn(1); // 高亮回放
    if (execute) {
      sethlBtn(3); // 高亮执行
      return;
    }
    if (data?.share_id_html) {
      sethlBtn(2); // 高亮网页
      return;
    }
  }, [data]);

  const handleClick = (e, btn) => {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    if (hlBtn === 3) {
      execute(data);
      return;
    }
    if (hlBtn === 2) {
      handleWeb(data.share_id_html);
      return;
    }
    handleReplay(data.share_id);
  };

  /** 做同款 */
  const handleFollow = data => {
    fieldCategoryStore.setCurrentCate(data);
  };
  return (
    <div
      key={key}
      className={[
        'w-full relative group recommond-case pt-16px bg-[#fff]  border-1px border-black border-opacity-16 rounded-12px overflow-hidden',
        className,
      ]}
      // onClick={handleClick}
    >
      <div className="flex w-full relative px-16px ">
        <div className="case-info flex-1">
          <h3 className="w-full line-clamp-1  text-16px leading-22px mb-0 break-all">
            {data.title}
          </h3>
          <p className="h-51px line-clamp-3 text-12px text-[rgba(0,0,0,0.5)] mt-4px mb-6px leading-17px break-all">
            {data.sub_title}
          </p>
          {/* <div className="text-12px text-[rgba(0,0,0,0.5)] leading-17px">@ {data.creator}</div> */}
        </div>
        <div className="case-cover relative w-56px h-74px bg-[#EEE] rounded-12px ml-12px">
          {data.cover && (
            <>
              <img
                className="w-full h-full object-cover rounded-6px"
                src={data.cover}
              />
              <span className="absolute top-0 left-0 w-full h-full bg-none border-1px border-[rgba(0,0,0,0.06)] rounded-6px"></span>
            </>
          )}
        </div>
      </div>

      <div
        className="flex h-31px items-center justify-between px-16px mt-4px bg-[#f7f7f7] "
        style={{
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
        }}
      >
        <div className="text-12px text-[rgba(0,0,0,0.5)]">@ {data.creator}</div>
        {data.share_id ? (
          <div
            onClick={e => {
              e.stopPropagation();
              handleReplay(data.share_id);
            }}
            className="flex items-center text-[#006AFF]"
          >
            <span className="mr-4px">任务详情</span>
            <SVGPureIcon name="bule_arrow" className="size-12px" />
          </div>
        ) : null}
      </div> 

      <div
        className={[
          ' absolute bottom-0 left-0 h-80px w-full px-16px pt-40px flex justify-center gap-13px ',
          'bottom-[-80px] group-hover:bottom-0 transition-all duration-500 ease-in-out',
        ]}
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 58.33%)',
        }}
      >
        {/* 输入执行 */}
        {(client.isLLQ || client.isSeLLQ) ? (
          <div
            className={[
              'w-full h-32px  flex justify-center items-center',
              'leading-32px text-14px rounded-6px',
              'cursor-pointer border-[#000] border-1px hover:bg-[rgba(0,0,0,0.03)] bg-[#fff] text-[#000]',
            ]}
            onClick={e => {
              e.stopPropagation();
              if (secne == "agent_landing_page") {
                execute && execute(data)
              } else {
                handleFollow(data);
              }
              
            }}
          >
            做同款
          </div>
        ) : null}

        {data.share_id ? (
          <div
            className={[
              'w-full h-32px flex justify-center items-center',
              'leading-32px text-13px rounded-6px',
              'cursor-pointer',
              'bg-black hover:bg-[#333] text-white',
            ]}
            onClick={e => {
              e.stopPropagation();
              handleReplay(data.share_id);
            }}
          >
            查看任务详情
          </div>
        ) : null}
      </div>
    </div>
  );

  return (
    <div
      key={data.share_id}
      className={[
        'w-full flex flex-col datas-start group',
        'rounded-16px overflow-hidden border-1px border-black-10 bg-white',
        'cursor-pointer',
        className,
      ]}
      onClick={handleClick}
    >
      {/* 封面/query */}

      {
        <div
          className="w-full pt-[65.5%] bg-black bg-opacity-3 relative"
          style={
            data.cover
              ? {
                  background: `url(${data.cover}) no-repeat top center`,
                  backgroundSize: '100% auto',
                }
              : {}
          }
        >
          {!data.cover && (
            <div
              className={[
                'absolute top-12px px-14px box-content text-14px text-black text-opacity-70',
              ]}
            >
              <div
                className="h-19px query-quotation"
                style={{
                  background: `url(${IconQuotation}) no-repeat top left`,
                  backgroundSize: '14px 10px',
                }}
              ></div>
              <p
                className={[
                  'query-history-text leading-20px text-ellipsis overflow-hidden',
                  isAgentHome
                    ? 'h-40px line-clamp-2 text-[rgba(0,0,0,0.5)]'
                    : 'h-60px line-clamp-3',
                ]}
              >
                {data.query}
              </p>
            </div>
          )}

          {/* hover弹层 */}
          <div
            className={[
              isAgentHome ? 'pt-10px' : '',
              'group-hover:opacity-100 opacity-0 absolute bottom-0 h-96px w-full px-14px flex flex-col justify-center items-center',
              !data.share_id_html && '!justify-end', // 当只有 查看回放
            ]}
            style={{
              background:
                'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.60) 32.79%, #FFF 95.5%)',
            }}
          >
            {/* 输入执行 */}
            {execute ? (
              <div
                className={[
                  'w-full h-32px  flex justify-center items-center',
                  'leading-32px text-14px rounded-6px cursor-pointer',
                  hlBtn === 3 && 'bg-black hover:bg-[#333] text-white',
                ]}
                onClick={e => {
                  e.stopPropagation();
                  execute(data);
                }}
              >
                <img
                  src={IconExecute}
                  className="w-16px h-16px mr-6px"
                  onError={e => {
                    e.target.src = IconExecute;
                  }}
                />
                输入执行
              </div>
            ) : (
              <div
                className={[
                  'w-full h-32px  flex justify-center items-center',
                  'leading-32px text-14px rounded-6px',
                  'cursor-pointer',
                  !data.share_id_html && 'hidden',
                  hlBtn === 2 && 'bg-black hover:bg-[#333] text-white',
                ]}
                onClick={e => {
                  e.stopPropagation();
                  handleWeb(data.share_id_html);
                }}
              >
                <img
                  src={IconWeb}
                  className="w-16px h-16px mr-6px"
                  onError={e => {
                    e.target.src = IconWeb;
                  }}
                />
                查看网页
              </div>
            )}

            {data.share_id ? (
              <div
                className={[
                  'w-full h-32px mt-8px flex justify-center items-center',
                  'leading-32px text-14px rounded-16px',
                  'cursor-pointer',
                  !data.share_id_html && 'mb-12px', // 当只有 查看回放
                  hlBtn === 1
                    ? 'bg-black hover:bg-[#333] text-white'
                    : 'bg-[#F0F0F0] hover:bg-[#E9E9E9] text-black',
                ]}
                onClick={e => {
                  e.stopPropagation();
                  handleReplay(data.share_id);
                }}
              >
                <img
                  src={hlBtn === 1 ? IconReplayC : IconReplay}
                  className="w-16px h-16px mr-6px"
                  onError={e => {
                    e.target.src = IconReplay;
                  }}
                />
                查看回放
              </div>
            ) : null}
          </div>
        </div>
      }

      {/* 标题/creator */}
      <div
        className={[
          isAgentHome ? 'px-8px py-12px' : 'px-14px py-12px',
          'bg-white  w-full flex flex-col datas-start justify-end',
        ]}
      >
        <div
          className={[
            'w-full leading-20px text-14px text-black',
            isAgentHome ? 'leading-16px !h-16px' : 'leading-20px',
            execute ? 'text-opacity-70' : 'text-opacity-100',
            `h-${lineClamp * 20}px line-clamp-${lineClamp} text-ellipsis overflow-hidden `,
          ]}
        >
          {data.title}
        </div>
        <div className="mt-3px leading-20px h-20px text-12px text-black text-opacity-50">
          {data.creator}
        </div>
      </div>
    </div>
  );
};

export default AgentItemCard;
